import React, { Component } from 'react';
import {
    message, Button, Select,
} from 'antd';
import { connect } from 'react-redux';
import axios from 'axios';
import ReactS3 from './ReactS3';
import './UploadPrescriptionIMG.css';
import ImageModal from './ImageModal';
import {
    ADD_PPRESCRIPTION_URL, DELETE_PRESCRIPTION_URL_AT_POSITION, SET_PARTNERS, UPDATE_PPRESCRIPTION,
} from '../../ActionTypes/ActionTypes';


const config = {
    bucketName: 'caredose-prescription-images-public',
    dirName: '',
    region: 'ap-south-1',
    accessKeyId: 'AKIASDALNULHVOERS6Z2',
    secretAccessKey: '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',
};

const { Option } = Select;

/*  Notice that if you don't provide a dirName, the file will be automatically uploaded to the root of your bucket */


// S3FileUpload
//     .uploadFile(file, config)
//     .then(data => console.log(data))
//     .catch(err => console.error(err))

// //** OR *//

// uploadFile(file, config)
//     .then(data => console.log(data))
//     .catch(err => console.error(err))

/**
   * {
   *   Response: {
   *     bucket: "your-bucket-name",
   *     key: "photos/image.jpg",
   *     location: "https://your-bucket.s3.amazonaws.com/photos/image.jpg"
   *   }
   * }
   */

class UploadPrescription extends Component {
    state = {
        locations: [],
        selectedPartner: '',
        selectedLocation: '',
        selectedImage: '',
        visibleImage: false,
        url: '',
    };

    componentDidMount = () => {
        const { order_id, partners_list } = this.props;
        config.dirName = order_id;

        if (partners_list.length === 0) {
            this.loadPartners();
        }
    };

    loadPartners = () => {
        const { setPartners } = this.props;

        axios({
            method: 'get',
            url: '/partners.json',
            headers: { Authorization: sessionStorage.getItem('jwtToken') },
        })
            .then((response) => {
                setPartners(response.data);
            })
            .catch((error) => {
                alert(`Internet Not working, Please check you connection: ${error.code}`);
            });
    };

    showImageModal = (link) => {
        this.setState({
            visibleImage: true,
            url: link,
        });
    }

    handleImageCancel = () => {
        // console.log(e);
        this.setState({
            visibleImage: false,
        });
    }

    handlePartnerChange = (value) => {
        const { partners_list } = this.props;

        const locations = partners_list.filter(partner => (
            partner.id === value
        ))[0].partner_locations;

        this.setState({
            selectedPartner: value,
            locations,
        });
    }

    handleLocationChange = (value) => {
        console.log(value);
        this.setState({
            selectedLocation: value,
        });
    }

    handleEdit = (id) => {
        this.setState({
            selectedImage: id,
        });
    }

    handleSave = (id) => {
        const { selectedPartner, selectedLocation } = this.state;
        const { p_prescriptions_url, updatePPrescription } = this.props;

        const indexToUpdate = p_prescriptions_url.indexOf(p_prescriptions_url.filter(pres => pres.id === id)[0]);
        // console.log(indexToUpdate);
        axios({
            method: 'put',
            url: `/p_prescriptions/${id}.json`,
            headers: { Authorization: sessionStorage.getItem('jwtToken') },
            data: {
                p_prescription: {
                    partner_id: selectedPartner,
                    partner_location_id: selectedLocation,
                },
            },
        })
            .then((response) => {
                console.log(response.data);
                updatePPrescription(indexToUpdate, response.data);
                window.location.reload();
            });
        this.setState({
            selectedImage: '',
        });
    }

    onChange = (event) => {
        const { addUrlToPPrescriptionList, e_prescription_id } = this.props;
        ReactS3.uploadFile(event.target.files[0], config)
            .then((response) => {
                // console.log(response);
                if (e_prescription_id !== '') {
                    axios({
                        method: 'post',
                        url: '/p_prescriptions.json',
                        headers: { Authorization: sessionStorage.getItem('jwtToken') },
                        data: {
                            p_prescription: {
                                photo_link: response.location,
                                e_prescription_id,
                            },
                        },
                    })
                        .then((resp) => {
                            console.log(resp.data);
                            addUrlToPPrescriptionList({ ...resp.data });
                            message.success('File Upload Successfull');
                        });
                } else {
                    addUrlToPPrescriptionList({ photo_link: response.location });
                    message.success('File Upload Successfull');
                }
            })
            .catch((err) => {
                message.error('File Upload Failed');
                alert(err);
            });
    };

    downloadPrescription = (url) => {
        window.location.href = url.photo_link;
    };

    deletePPrescription = (filename, id, index) => {
        const { deleteUrlFromPPrescription } = this.props;

        axios({
            method: 'delete',
            url: `/p_prescriptions/${id}.json`,
            headers: { Authorization: sessionStorage.getItem('jwtToken') },
        }).then((response) => {
            // console.log(response);
            deleteUrlFromPPrescription(index);
        });
        // ReactS3.deleteFile(filename, config)
        //     .then((response) => {
        //         deleteUrlFromPPrescription(index);
        //     })
        //     .catch(err => console.error(err));
    }

    render() {
        const { p_prescriptions_url, partners_list } = this.props;
        const {
            visibleImage, url, locations, selectedImage,
        } = this.state;

        const partnerOptions = partners_list.map(partner => (
            <Option key={partner.id} value={partner.id}>
                {partner.name}
            </Option>
        ));

        const locationOptions = locations.map(location => (
            <Option key={location.id} value={location.id}>
                {location.name}
            </Option>
        ));

        return (
            <div className="container m-auto">

                <p className="d-inline lead">
                    Upload Prescription {p_prescriptions_url.length + 1}
                </p>

                <div style={{ marginTop: 30, textAlign: 'center' }}>
                    <input className="d-inline" type="file" accept=".jpg, .jpeg, .png, .pdf" onChange={this.onChange} />
                </div>

                <br />
                <br />

                {p_prescriptions_url.length !== 0
                    ? (
                        <div className="grid-container">
                            {
                                p_prescriptions_url.map((imgLink, index) => (
                                    <div style={{ width: '100%' }}>
                                        <div className="grid-item" key={index}>
                                            <span onClick={() => this.showImageModal(imgLink.photo_link)} role="button" style={{ cursor: 'pointer' }}>
                                                <img
                                                    alt="Prescription"
                                                    src={imgLink.photo_link}
                                                    width="150"
                                                    height="200"
                                                />
                                            </span>

                                            <div>
                                                <p>{imgLink.name}</p>
                                            </div>

                                            <div>
                                                <div>
                                                    <Select style={{ width: 180 }} defaultValue={imgLink.partner_id} onChange={this.handlePartnerChange} disabled={selectedImage !== imgLink.id}>
                                                        {partnerOptions}
                                                    </Select>
                                                </div>

                                                <div>
                                                    {
                                                        selectedImage !== imgLink.id
                                                            ? (
                                                                <p style={{ fontSize: 18, marginTop: 10 }}>{imgLink.location_name == null ? 'Not Selected' : imgLink.location_name}</p>
                                                            )
                                                            : (
                                                                <Select style={{ width: 180 }} defaultValue={imgLink.location_name} onChange={this.handleLocationChange} disabled={selectedImage !== imgLink.id}>
                                                                    {locationOptions}
                                                                </Select>
                                                            )
                                                    }
                                                </div>

                                                {
                                                    selectedImage !== imgLink.id
                                                        ? (
                                                            <Button onClick={() => this.handleEdit(imgLink.id)} type="primary" icon="edit">Edit</Button>
                                                        )
                                                        : (
                                                            <Button onClick={() => this.handleSave(imgLink.id)} type="primary" icon="save">Save</Button>
                                                        )
                                                }

                                            </div>

                                            <br />
                                            <Button type="danger" shape="circle" icon="delete" onClick={() => this.deletePPrescription(imgLink, imgLink.id, p_prescriptions_url.indexOf(imgLink))} />
                                            <div style={{ marginRight: 20, display: 'inline' }} />
                                            <Button type="primary" shape="circle" icon="download" onClick={() => this.downloadPrescription(imgLink)} />
                                        </div>
                                    </div>
                                ))
                            }
                        </div>
                    )
                    : null
                }
                <ImageModal
                    visible={visibleImage}
                    url={url}
                    handleCancel={this.handleImageCancel}
                />


                <br />

            </div>
        );
    }
}

const mapStateToProps = state => ({
    p_prescriptions_url: state.AppState.p_prescriptions_url,
    order_id: state.AppState.order_id,
    medicineList: state.AppState.medicineList,
    end_date: state.AppState.end_date,
    e_prescription_id: state.AppState.ep_id,
    partners_list: state.AppState.partners_list,
});

const mapDispatchToProps = dispatch => ({
    addUrlToPPrescriptionList: url => dispatch({ type: ADD_PPRESCRIPTION_URL, url }),
    deleteUrlFromPPrescription: id => dispatch({ type: DELETE_PRESCRIPTION_URL_AT_POSITION, id }),
    setPartners: partners => dispatch({ type: SET_PARTNERS, payload: { partners } }),
    updatePPrescription: (id, data) => dispatch({ type: UPDATE_PPRESCRIPTION, payload: { id, data } }),
});

export default connect(mapStateToProps, mapDispatchToProps)(UploadPrescription);



// WEBPACK FOOTER //
// ./src/component/UploadPrescriptionIMG/UploadPrescriptionIMG.js